import "./style.css";
import ReactDOM from "react-dom/client";
import { Canvas } from "@react-three/fiber";
import Experience from "./Experience.jsx";
import { KeyboardControls } from "@react-three/drei";
import Interface from "./Interface.jsx";
import { Suspense } from "react";
import { preloadModels } from "./components/loader/preload.js";
import useDeviceType from "./components/hooks/useDeviceType";

// Предзагрузка всех моделей для ускорения инициализации сцены
preloadModels();

const root = ReactDOM.createRoot(document.querySelector("#root"));

const App = () => {
  const deviceType = useDeviceType();

  // Позиция камеры и FOV: дальше и шире для мобильных и планшетов
  const isMobile = deviceType === "mobile" || deviceType === "tablet";
  const cameraPosition = [2.5, 5, 5]; // Ближе для десктопа

  const cameraFov = isMobile ? 70 : 50; // Более широкий угол обзора для мобильных

  return (
    <KeyboardControls
      map={[
        { name: "forward", keys: ["ArrowUp", "KeyW"] },
        { name: "backward", keys: ["ArrowDown", "KeyS"] },
        { name: "left", keys: ["ArrowLeft", "KeyA"] },
        { name: "right", keys: ["ArrowRight", "KeyD"] },
        { name: "jump", keys: ["Space"] },
        { name: "reset", keys: ["KeyR"] },
        { name: "start", keys: ["Enter"] },
      ]}
    >
      <Canvas
        shadows
        camera={{
          fov: cameraFov,
          near: 0.1,
          far: 100,
          position: cameraPosition,
        }}
      >
        {/* Рендерим Experience всегда для загрузки, но скрываем до клика */}
        <Suspense fallback={null}>
          <Experience />
        </Suspense>
      </Canvas>

      <Interface />
    </KeyboardControls>
  );
};

root.render(<App />);
